import { TThunkAction } from '../../../../common/types/thunk';
import { EPlacingType, EServiceId } from '../../../types/reducers/publishTerms';
import { ECheckServicePromotionType, ECheckServicePublicationType } from '../../../services/checkService';
import { selectServiceIds } from '../../../selectors/publishTerms';
import {
  changeActiveServiceId,
  changeIsServicesEnabled,
  changePromotionService,
  changeSelectedPackageId,
  selectPlacingType,
} from '../../../actions/publishTerms';
import { reloadBetPosition } from '../../../actions/betPosition';
import { loadPublishTerms } from '../../publishTerms/loadPublishTerms';

import { PACKAGE_TYPES, PUBLICATION_TYPES } from './constants';
import { getNextServiceId, getPackageId } from './utils';
import { selectActivePackageId, selectPackages } from '../../../reducers/v2/publicationPackages/selectors';

interface IParams {
  publicationType: ECheckServicePublicationType;
  promotionType: ECheckServicePromotionType;
  serviceId: EServiceId;
}

export const changeSelectedServiceAfterCheckService =
  ({ serviceId, promotionType, publicationType }: IParams): TThunkAction<Promise<void>> =>
  async (dispatch, getState) => {
    const state = getState();

    const serviceIds = selectServiceIds(state);
    const nextServiceId = getNextServiceId(serviceId, promotionType, serviceIds);

    dispatch(changePromotionService(nextServiceId));
    dispatch(changeActiveServiceId(nextServiceId));

    const isPublication = PUBLICATION_TYPES.includes(publicationType);
    // снова переключаемся на публикацию с баланса, на случай переключения в другой тип услуг
    if (isPublication) {
      dispatch(selectPlacingType(EPlacingType.balance));
    }

    const isPackage = PACKAGE_TYPES.includes(publicationType);
    // снова переключаемся в пакеты, на случай переключения в другой тип услуг
    if (isPackage) {
      const packages = selectPackages(state);
      const packageId = getPackageId({ packages, serviceId, publicationType });
      const currentSelectedPackageId = selectActivePackageId(state);

      if (currentSelectedPackageId !== packageId) {
        dispatch(loadPublishTerms({ isServicesReload: true }));
      }

      dispatch(changeSelectedPackageId(packageId));
      dispatch(selectPlacingType(EPlacingType.package));
    }

    const shouldEnableServices = promotionType !== ECheckServicePromotionType.noPromotion;
    dispatch(changeIsServicesEnabled(shouldEnableServices));

    dispatch(reloadBetPosition());
  };
